require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/phocks/Sites/gatsby-site/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/phocks/Sites/gatsby-site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/phocks/Sites/gatsby-site/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/phocks/Sites/gatsby-site/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/phocks/Sites/gatsby-site/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/phocks/Sites/gatsby-site/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./404.js") })
        }
      }, "component---src-pages-404-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-404-js!./src/pages/404.js
// module id = 307
// module chunks = 231608221292675